import { render, staticRenderFns } from "./Modify.vue?vue&type=template&id=16cd24d2&scoped=true&"
import script from "./Modify.vue?vue&type=script&lang=ts&"
export * from "./Modify.vue?vue&type=script&lang=ts&"
import style0 from "./Modify.vue?vue&type=style&index=0&id=16cd24d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cd24d2",
  null
  
)

export default component.exports